import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import httpClient from '@utils/httpClient.js';

export const fetchKeywordIdeas = createAsyncThunk('googleAds/fetchKeywordIdeas', async ({ profileId, customerId, accessToken, keywords, url }) => {
  const params = new URLSearchParams({ customerId, accessToken });
  if (keywords) params.append('keywords', keywords);
  if (url) params.append('url', url);
  const res = await httpClient.get(`/api/profiles/${profileId}/ads/google/keywords/ideas?${params}`);
  return res.data;
});

export const fetchGoogleAccounts = createAsyncThunk('googleAds/fetchGoogleAccounts', async ({ profileId, accessToken }) => {
  const params = new URLSearchParams({ accessToken });
  const res = await httpClient.get(`/api/profiles/${profileId}/ads/google/accounts?${params}`);
  return res.data;
});

export const fetchGeoTargets = createAsyncThunk('googleAds/fetchGeoTargets', async ({ profileId, customerId, accessToken, query }) => {
  const params = new URLSearchParams({ customerId, accessToken, q: query });
  const res = await httpClient.get(`/api/profiles/${profileId}/ads/google/targeting/geo?${params}`);
  return res.data;
});

export const fetchAudiences = createAsyncThunk('googleAds/fetchAudiences', async ({ profileId, customerId, accessToken }) => {
  const params = new URLSearchParams({ customerId, accessToken });
  const res = await httpClient.get(`/api/profiles/${profileId}/ads/google/targeting/audiences?${params}`);
  return res.data;
});

const googleAdsSlice = createSlice({
  name: 'googleAds',
  initialState: {
    keywordIdeas: [],
    accounts: [],
    geoTargets: [],
    audiences: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearKeywordIdeas: (state) => {
      state.keywordIdeas = [];
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Keyword Ideas
      .addCase(fetchKeywordIdeas.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchKeywordIdeas.fulfilled, (state, action) => {
        state.loading = false;
        state.keywordIdeas = action.payload;
      })
      .addCase(fetchKeywordIdeas.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Google Accounts
      .addCase(fetchGoogleAccounts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchGoogleAccounts.fulfilled, (state, action) => {
        state.loading = false;
        state.accounts = action.payload;
      })
      .addCase(fetchGoogleAccounts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Geo Targets
      .addCase(fetchGeoTargets.fulfilled, (state, action) => {
        state.geoTargets = action.payload;
      })
      // Audiences
      .addCase(fetchAudiences.fulfilled, (state, action) => {
        state.audiences = action.payload;
      });
  },
});

export const { clearKeywordIdeas, clearError } = googleAdsSlice.actions;
export const selectKeywordIdeas = (state) => state.googleAds.keywordIdeas;
export const selectGoogleAdsLoading = (state) => state.googleAds.loading;
export const selectGoogleAdsError = (state) => state.googleAds.error;
export const selectGoogleAccounts = (state) => state.googleAds.accounts;

export default googleAdsSlice.reducer;
